import { render, staticRenderFns } from "./AssignmentAITutorDetail.vue?vue&type=template&id=3604e6ae&scoped=true&"
import script from "./AssignmentAITutorDetail.vue?vue&type=script&lang=js&"
export * from "./AssignmentAITutorDetail.vue?vue&type=script&lang=js&"
import style0 from "./AssignmentAITutorDetail.vue?vue&type=style&index=0&id=3604e6ae&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3604e6ae",
  null
  
)

export default component.exports